module.exports = __webpack_public_path__ + "favicon.ico?f8241fb585d7959284d6c9a6d08e0a2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicons/favicon.ico
// module id = 25
// module chunks = 0